import React from "react";
import "./UploadFiles.css";

const UploadLinks = () => {
  return (
    <div className="xena-upload-docs">
      <h1 className="xena-upload-title">
        Adding Web Links and Cloud Documents
      </h1>

      <p className="xena-upload-intro">
        Learn how to add web links and cloud documents as training data for your XenaChat assistant.  
        By linking structured online content, your bot can reference and respond using the resources you provide.
      </p>

      <h2 className="xena-upload-section">Step 1 – Open Your Bot</h2>
      <p>
        From the <strong>Dashboard</strong>, go to <strong>Your Bots</strong> and select the bot you want to train.
      </p>

      <h2 className="xena-upload-section">Step 2 – Access Training Sources</h2>
      <p>
        In the left sidebar, click on <strong>Training</strong>, then choose <strong>Sources</strong>.
      </p>

      <h2 className="xena-upload-section">Step 3 – Add Links</h2>
      <p>
        Click on the <strong>Links</strong> tab. Then click <strong>Add URLs</strong> to input the web addresses of your documents or resources.
      </p>

      <ul className="xena-upload-list">
        <li>Supported links: PDF, DOC, DOCX, TXT, or cloud document URLs</li>
        <li>Paste URLs or import from cloud services</li>
        <li>Wait while XenaChat fetches and processes the content</li>
      </ul>

      <h2 className="xena-upload-section">After Adding Links</h2>
      <p>
        Once URLs are added, XenaChat automatically processes and indexes the linked content.  
        After processing, your assistant can use these resources to deliver accurate, context-aware responses.
      </p>
    </div>
  );
};

export default UploadLinks;
